import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../axios";
// import ProductGallery from "../components/ProductDetail/ProductGallery";
import ProductInfo from "../components/ProductDetail/ProductInfo";
import ProductFeature from "../components/ProductDetail/ProductFeature";
import ProductOrderForm from "../components/ProductDetail/ProductOrderForm";
import ProductImageGallery from "../components/ProductDetail/ProductImageGallery";
import { STORAGE_URL } from "../../constants";

export default function ProductDetailPage() {
    const { id } = useParams();
    const [product, setProduct] = useState(null);

    useEffect(() => {
        axios.get(`/products/${id}`)
            .then((res) => setProduct(res.data))
            .catch(() => alert("Gagal memuat produk"));
    }, [id]);

    if (!product) return <p className="text-center mt-5">Memuat produk...</p>;

    return (
        <div className="">
            <div class="row gy-4">
                <div class="col-md-8">
                    
                    <div class="card">
                        <div class="card-body p-lg-20 p-sm-3">
                            <ProductInfo product={product} />
                            

                            <div class="rounded-16 overflow-hidden">
                                <ProductImageGallery photos={product.photos.map(photo => `${STORAGE_URL}${photo['file_path']}`)} />
                                {/* <ProductGallery photos={product.photos} /> */}
                                {/* <img src="assets/images/courses/course-img1.jpg" alt="Course Image" class="w-100 h-100 object-fit-cover" /> */}
                            </div>

                            <ProductFeature html={product.feature_and_design} />
                            
                        </div>
                    </div>
                    
                </div>

                <div class="col-md-4">
                    <div class="card ">
                        <div class="card-body">
                            <ProductOrderForm product={product} />

                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
}
